Controller = App.loadClass 'core::Angular/Controller'

class exports.SeasonDetailsController extends Controller
    constructor: (
        @scope,
        @transitions,
        @modal,
        @http,
        @service,
        @state
    ) ->
        super

        alert_date = moment(@service.survey.growth_stage_last_updated).add(2, 'weeks')
        @displayGrowthStageAlert = alert_date.isBefore()

        # Business rules say that even if the user so much as visits the page, update growth_stage_last_updated
        @service.survey.growth_stage_last_updated = moment().format('YYYY-MM-DD HH:mm:ss')
